export const PROFILE_PROPS = {
  TIMEZONE: {
    SELECT_TIMEZONE_PLACEHOLDER: 'Select Timezone',
    TIMEZONE: 'Timezone',
  },
  SPINNER_PROPS: {
    TYPE: 'clock',
    SIZE: '40px',
    COLOR: '#000',
    BG_COLOR: '#ffffff',
    ANIMATION_DURATION: '5s',
    MESSAGE: 'Setting up the timezone for you.. Please Wait..!!',
    MESSAGEPO: 'Setting up the Provider/Operator for you.. Please Wait..!!',
    MESSAGE_SIZE: '30px',
    HIDE_DURATION: 1000,
    APPLYING_TEXT: 'Applying changes\u2026',
    WAIT_TEXT: 'Please wait',
  },
  SECTIONS: {
    TIMEZONE_TITLE: 'Default Timezone',
    TIMEZONE_SUBTITLE: 'Your local time reference for dates & timestamps',
    PROVIDER_OP_TITLE: 'Default Provider / Operator',
    PROVIDER_OP_SUBTITLE: 'Pre-selected context when you log in',
    APPEARANCE_TITLE: 'Appearance',
    APPEARANCE_SUBTITLE: 'Choose light, dark, or follow your device',
    THEME_TITLE: 'App Theme',
    THEME_SUBTITLE: 'Global accent color applied everywhere',
  },
  THEME: {
    LIGHT: { LABEL: 'Light', DESC: 'Always bright' },
    DARK: { LABEL: 'Dark', DESC: 'Easy on eyes' },
    SYSTEM: { LABEL: 'System', DESC: 'Auto detect' },
  },
  PALETTE: {
    SOLID_LABEL: 'Solid',
    GRADIENT_LABEL: 'Gradient',
    NOTE: 'Changes apply instantly across the entire app',
  },
  USER_STATS: {
    NICKNAME_LABEL: 'Nickname',
    LAST_LOGGED_ON_LABEL: 'Last Logged On',
    NO_ROLE: 'No Role Assigned',
    EMPTY_VALUE: '\u2014',
  },
};
